import { render, staticRenderFns } from "./ReportFeedback.vue?vue&type=template&id=6da1cefe&scoped=true&"
import script from "./ReportFeedback.vue?vue&type=script&lang=js&"
export * from "./ReportFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ReportFeedback.vue?vue&type=style&index=0&id=6da1cefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1cefe",
  null
  
)

export default component.exports